<template>
  <div id="app">
    <home-main></home-main>
  </div>
</template>

<script>
  import HomeMain from "./views/Main";
  export default {

    components: {
      HomeMain
    }
  }
</script>

<style lang="scss">
  @import './scss/main';

</style>
